/* eslint-disable react/no-danger */

import { cx } from 'emotion';
import React from 'react';
import { moduleBorderStyle } from './moduleBorderStyle';

interface Props {
    data?: { body?: { text?: string } }; // TODO: pass only required information, not full data
}

export const TextModule: React.FC<Props> = ({ data }) => {
    return (
        <div>
            <div
                className={cx(
                    'dc-modules__item--text',
                    moduleBorderStyle,
                    'eds-l-pad-all-6',
                )}
                dangerouslySetInnerHTML={{ __html: data?.body?.text || '' }}
            />
        </div>
    );
};
